import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=5f2a57d4&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=5f2a57d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a57d4",
  null
  
)

export default component.exports